"use client";

import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-sls-selective-laser-sintering";

export default function SlsGeneralTolerances() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("slsTolerancesTitle")}
				</h2>

				<div className="overflow-x-auto border border-[#d0d3c9] bg-[#f6ffde]">
					<table className="w-full min-w-[600px] border-collapse text-left">
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th className="w-[35%] border border-[#d0d3c9] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesColDescription")}
								</th>
								<th className="border border-[#d0d3c9] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesColToleranceNotes")}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th
									scope="row"
									rowSpan={3}
									className="border border-[#d0d3c9] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("slsTolerancesRow1Label")}
								</th>
								<td className="border border-[#d0d3c9] px-4 py-4 text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesRow1Value1")}
								</td>
							</tr>
							<tr>
								<td className="border border-[#d0d3c9] px-4 py-4 text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesRow1Value2")}
								</td>
							</tr>
							<tr>
								<td className="border border-[#d0d3c9] px-4 py-4 text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesRow1Value3")}
								</td>
							</tr>
							<tr>
								<th
									scope="row"
									className="border border-[#d0d3c9] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("slsTolerancesRow2Label")}
								</th>
								<td className="border border-[#d0d3c9] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesRow2Value")}
								</td>
							</tr>
							<tr>
								<th
									scope="row"
									className="border border-[#d0d3c9] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("slsTolerancesRow3Label")}
								</th>
								<td className="border border-[#d0d3c9] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesRow3Value")}
								</td>
							</tr>
							<tr>
								<th
									scope="row"
									className="border border-[#d0d3c9] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("slsTolerancesRow4Label")}
								</th>
								<td className="border border-[#d0d3c9] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("slsTolerancesRow4Value")}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div className="mt-5 flex flex-col gap-4 sm:mt-6 sm:flex-row sm:items-end sm:justify-between">
					<p className="text-sm leading-relaxed text-black md:text-base">{t("slsTolerancesNote")}</p>
					<Link
						href="/contact-us"
						className="inline-flex w-fit shrink-0 items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("slsTolerancesContactUs")}
					</Link>
				</div>
			</div>
		</section>
	);
}
